import React from 'react';
import { AboutUs } from 'pages/aboutUs/AboutUs';
import { Gallery } from 'pages/gallery/Gallery';
import { DanceShow } from 'pages/danceShow/DanceShow';
import { WelcomeAnim } from 'pages/welcomeAnim/welcomAnim';
import { ContactUs } from 'pages/contactUs/ContactUs';
import {
    ABOUT_US_URL,
    CONTACT_US_URL,
    DANCE_SHOW_URL,
    GALLERY_URL,
    HOME_URL,
    WELCOME_ANIM_URL,
} from 'constants/navigation';

interface RouteConfig {
    path: string;
    element: JSX.Element;
}

export const routes: RouteConfig[] = [
    { path: ABOUT_US_URL, element: <AboutUs /> },
    { path: GALLERY_URL, element: <Gallery /> },
    { path: DANCE_SHOW_URL, element: <DanceShow /> },
    { path: WELCOME_ANIM_URL, element: <WelcomeAnim /> },
    { path: CONTACT_US_URL, element: <ContactUs /> },
];

// Helper function to get language-specific paths
export const getPath = (path: string, lang: string) => {
    const cleanPath = path.startsWith(HOME_URL) ? path : `/${path}`;
    return lang === 'en' ? `/en${cleanPath}` : cleanPath;
};
